export type Tone = 'neutral' | 'success' | 'warning' | 'danger' | 'info';

export function statusTone(status: string): Tone {
  switch (status) {
    case 'analyzed':
      return 'success';
    case 'analyzing':
    case 'parsing':
      return 'info';
    case 'parsed':
      return 'warning';
    case 'pending':
      return 'neutral';
    case 'failed':
      return 'danger';
    default:
      return 'neutral';
  }
}

export function statusLabel(status: string): string {
  switch (status) {
    case 'analyzed':
      return 'проверено';
    case 'analyzing':
      return 'анализ…';
    case 'parsing':
      return 'разбор…';
    case 'parsed':
      return 'распознано';
    case 'pending':
      return 'загружено';
    case 'failed':
      return 'ошибка';
    default:
      return status;
  }
}

export function linkKindLabel(link: string): string {
  switch (link) {
    case 'ks_pair':
      return 'пара КС-2';
    case 'contract_execution':
      return 'договор ↔ выполнение';
    default:
      return link;
  }
}

export function discrTone(sev: string): Tone {
  switch (sev) {
    case 'error':
      return 'danger';
    case 'warning':
      return 'warning';
    case 'info':
      return 'info';
    default:
      return 'neutral';
  }
}

export function kindLabel(kind: string): string {
  switch (kind) {
    case 'not_in_sp':
      return 'не передано субподряду';
    case 'not_in_gp':
      return 'нет в смете ГП';
    case 'qty_mismatch':
      return 'объём';
    case 'price_mismatch':
      return 'цена';
    case 'total_mismatch':
      return 'сумма';
    case 'nr_mismatch':
      return 'НР';
    case 'sp_mismatch':
      return 'СП';
    case 'ambiguous_match':
      return 'неоднозначный матч';
    case 'rollup_mismatch':
      return 'свод';
    case 'not_found_semantic':
      return 'матч по смыслу';
    default:
      return kind;
  }
}

/** Число из summary JSONB (движок пишет агрегаты маржи/покрытия). */
export function summaryNum(summary: Record<string, unknown> | null, key: string): number | null {
  if (!summary) return null;
  const v = summary[key];
  return typeof v === 'number' ? v : null;
}
